<template>
  <v-dialog
    v-model="dialog"
    width="max-content"
    content-class="elevation-0"
    :persistent="loading"
  >
    <v-row class="ma-0 pa-0">
      <v-col>
        <PurchaseCard
          v-model="dialog"
          :item="item"
          :acquisitionMethod="acquisitionMethod"
          :loading="loading"
          @confirm="emitConfirm"
          @reloadAcquisitionStrategy="reloadAcquisitionStrategy"
        />
      </v-col>
      <v-col v-if="upgradeable && subscription.auto_renew">
        <UpgradeSuggestion @click.stop :item="item" :plans="upgradeablePlans" />
      </v-col>
    </v-row>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex"
import PurchaseCard from "@/components/shared/PurchaseDialog/PurchaseCard.vue"
import UpgradeSuggestion from "@/components/shared/PurchaseDialog/UpgradeSuggestion.vue"
export default {
  props: ["item", "acquisitionMethod", "value", "loading"],
  components: { PurchaseCard, UpgradeSuggestion },
  computed: {
    ...mapGetters(["subscription", "plans", "currentPlan", "currentTenant"]),
    dialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      }
    },
    upgradeable() {
      if (this.acquisitionMethod === "quota") return false
      if (this.item.product_code === "GAUGEKIT-GEN2") return false
      if (!this.currentTenant.activated) return false

      const currentQuotaIncluded = this.currentPlan.quotas.find(
        (q) => q.code === this.item.quota_code
      ).included

      const upgradeable = this.plans.some(
        (p) =>
          p.tier > this.currentPlan.tier &&
          p.quotas.find((q) => q.code === this.item.quota_code).included >
            currentQuotaIncluded
      )
      return upgradeable
    },

    upgradeablePlans() {
      if (!this.upgradeable) return
      return this.plans.filter((p) => p.tier > this.currentPlan.tier)
    }
  },
  methods: {
    emitConfirm(paymentMethodId, shippingAddressUid) {
      this.$emit("confirm", paymentMethodId, shippingAddressUid)
    },
    reloadAcquisitionStrategy(shippingAddressUid) {
      this.$emit("reloadAcquisitionStrategy", shippingAddressUid)
    }
  }
}
</script>
